import { IIndexable } from "@constants/common";

// const noindexNofollow: string = "noindex, nofollow";
// const noindexFollow: string = "noindex, follow";

export const pathToRobots: IIndexable = {
  // "kernel-powering-the-next-era-of-restaking": noindexNofollow,
  // "high-growth-vault-faqs-all-your-questions-answered-2": noindexNofollow,
  // "high-growth-vault-is-live-now-get-high-on-rewards-in-just-1-click":
  //   noindexNofollow,
  // "binance-labs-invests-in-kernel-kelp-dao-to-shape-the-future-of-restaking-and-defi":
  //   noindexNofollow,
  // "unveiling-the-vision-kelp-and-kernels-journey-to-100bn-opportunities-2":
  //   noindexNofollow,
  // "introducing-highest-rewards-in-one-click": noindexNofollow,
  // "ageth-and-rseth-how-kelps-receipt-tokens-are-complementary": noindexNofollow,
  // "the-tech-powering-gain-by-kelp": noindexNofollow,
  // "complete-guide-to-faqs-about-gain-by-kelp": noindexNofollow,
  // "introducing-gain-powered-by-kelp": noindexNofollow,
  // "restaking-with-multiple-wallets": noindexNofollow,
  // "what-is-staking": noindexNofollow,
  // "how-to-restake-eth-maximize-your-crypto-earnings-with-kelp-dao-2":
  //   noindexNofollow,
  // "understanding-eigenlayer-restaking-rewards-and-points-in-ethereums-ecosystem":
  //   noindexNofollow,
  // "what-is-restaking-kelp-dao": noindexFollow,
  // "institutional-grade-restaking-platforms": noindexNofollow,
};
